import React, { useEffect, useState } from 'react';
import { buildWhatsAppLink, site } from '../../data/site';
import { IconPhone, IconWhatsApp } from '../ui/Icons';

export default function FloatingActions() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 520);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-5 right-4 z-[70] flex flex-col gap-3 transition-all duration-500 ease-luxe sm:bottom-7 sm:right-6 ${
        show ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-6 opacity-0'
      }`}
    >
      <a
        href={`tel:${site.phone}`}
        aria-label={`Call ${site.phoneDisplay}`}
        className="flex h-12 w-12 items-center justify-center bg-royal text-cream shadow-luxe transition-colors duration-400 hover:bg-royal-600 sm:h-[52px] sm:w-[52px]"
      >
        <IconPhone className="h-5 w-5" />
      </a>

      <a
        href={buildWhatsAppLink()}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="group relative flex h-12 w-12 items-center justify-center bg-[#1FA855] text-white shadow-luxe transition-transform duration-400 hover:scale-105 sm:h-[52px] sm:w-[52px]"
      >
        <span className="absolute inset-0 animate-ping bg-[#1FA855]/30" style={{ animationDuration: '2.6s' }} />
        <IconWhatsApp solid className="relative h-6 w-6" />
      </a>
    </div>
  );
}
